var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAparat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 22,
    viewBox: "0 0 23 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 0.333336C5.60871 0.333336 0.833374 5.10867 0.833374 11C0.833374 16.8913 5.60871 21.6667 11.5 21.6667C17.3914 21.6667 22.1667 16.8913 22.1667 11C22.1667 5.10867 17.3914 0.333336 11.5 0.333336ZM8.83337 3.66667C10.306 3.66667 11.5 4.86067 11.5 6.33334C11.5 7.806 10.306 9 8.83337 9C7.36071 9 6.16671 7.806 6.16671 6.33334C6.16671 4.86067 7.36071 3.66667 8.83337 3.66667ZM6.83337 16.3333C5.36071 16.3333 4.16671 15.1393 4.16671 13.6667C4.16671 12.194 5.36071 11 6.83337 11C8.30604 11 9.50004 12.194 9.50004 13.6667C9.50004 15.1393 8.30604 16.3333 6.83337 16.3333ZM10.1667 11C10.1667 10.2633 10.7634 9.66667 11.5 9.66667C12.2367 9.66667 12.8334 10.2633 12.8334 11C12.8334 11.7367 12.2367 12.3333 11.5 12.3333C10.7634 12.3333 10.1667 11.7367 10.1667 11ZM14.1667 18.3333C12.694 18.3333 11.5 17.1393 11.5 15.6667C11.5 14.194 12.694 13 14.1667 13C15.6394 13 16.8334 14.194 16.8334 15.6667C16.8334 17.1393 15.6394 18.3333 14.1667 18.3333ZM16.1667 11C14.694 11 13.5 9.806 13.5 8.33334C13.5 6.86067 14.694 5.66667 16.1667 5.66667C17.6394 5.66667 18.8334 6.86067 18.8334 8.33334C18.8334 9.806 17.6394 11 16.1667 11Z",
    fill: "#8E92AA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAparat);
export default __webpack_public_path__ + "static/media/aparat.2c17a2cd68eb95a84fe02df0e997276e.svg";
export { ForwardRef as ReactComponent };